import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageUrl',
  standalone: true,
})
export class ImageUrlPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(@Inject('baseS3Path') private readonly baseS3Path: string) {}

  transform(imageFileKey: string, size?: string): string {
    if (size) {
      return `${this.baseS3Path}/images/${size}/${imageFileKey}`;
    } else {
      return `${this.baseS3Path}/images/${imageFileKey}`;
    }
  }
}
